/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import {
  useDeleteCustomActionMutation,
  DeleteCustomActionMutation,
} from "~/generated/graphql";
import { showError } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useDeleteCustomAction({ onSuccess }: Props) {
  const [id, setId] = useState("");
  const [deleteCustomActionMutation, { client, ...rest }] =
    useDeleteCustomActionMutation({
      onCompleted: (data: DeleteCustomActionMutation) => {
        if (data.removeAction) {
          onSuccess();
          removeFromApolloCache(client.cache, `Action:${id}`, "actions");
        } else {
          showError();
        }
      },
    });

  async function deleteCustomAction(actionId: string) {
    setId(actionId);
    await deleteCustomActionMutation({
      variables: {
        id: actionId,
      },
    });
  }

  return [deleteCustomAction, { client, ...rest }] as const;
}
